import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import type { StaffRole } from './storage'

/**
 * Гейт авторизации для роутов. Без сессии — редирект на /login
 * (с запоминанием исходного пути в state.from).
 * Если переданы roles — также проверяет роль (super_admin проходит всегда).
 * Если передан deny — эти роли НЕ пускаются (super_admin — исключение); используется,
 * чтобы закрыть разделы для ограниченной роли (напр. «Бухгалтер»).
 */
export function RequireAuth({
  roles,
  deny
}: {
  roles?: StaffRole[]
  deny?: StaffRole[]
}): React.JSX.Element {
  const { isAuthenticated, isSuperAdmin, hasRole } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (roles && roles.length > 0 && !isSuperAdmin && !hasRole(...roles)) {
    return <Navigate to="/" replace />
  }

  if (deny && deny.length > 0 && !isSuperAdmin && hasRole(...deny)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
